import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[appPasswordValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PasswordValidatorDirective,
    multi: true
  }]
})
export class PasswordValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    const errors = {}
    if (!control.value || control.value.length < 8) {
      errors['pw_length']=true;
    }
    if (control.value && !control.value.match(/[0-9]/)) {
      errors['pw_numbers']=true;
    }
    if (control.value && !control.value.match(/[a-z]/)) {
      errors['pw_lowercase']=true;
    }
    if (control.value && !control.value.match(/[A-Z]/)) {
      errors['pw_uppercase']=true;
    }
    if (control.value && !control.value.match(/[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]/)) {
      errors['pw_special']=true;
    }
    return errors
  }
}
